import React from "react";
import { useSelector } from "react-redux";
import { getProbablesEmptyMessage } from "../../../../store/selectors";
import EmptyCaseDialogMessage from "../../EmptyCaseDialogMessage";

const EmptyCase = () => {
  const { description, title } = useSelector(getProbablesEmptyMessage);

  return (
    <EmptyCaseDialogMessage
      title={title}
      description={description}
      qaLabel="probables-empty-message"
      iconName="info"
    />
  );
};

export default React.memo(EmptyCase);
